import { Icon } from "@progress/kendo-react-common";
import { GridCellProps } from "@progress/kendo-react-grid";
import { CustomGridCell } from ".";

export const BooleanGridCell = (props: GridCellProps) => {
  const field = props.field || "";
  const value = props.dataItem[field];

  return (
    <CustomGridCell {...props} style={{ textAlign: "center" }}>
      {value ? <Icon name="check" themeColor="primary" /> : ""}
    </CustomGridCell>
  );
};
